export default __webpack_public_path__ + "static/media/tommie.305a25e5.jpg";